// This MUST be the first import
import './polyfills';

// Then other imports
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { Login } from './pages/Login'
import { ProtectedRoute } from './components/ProtectedRoute'
import { AppShell } from './components/AppShell'
import './index.css'

// Ensure axios is available globally for easier debugging if needed
import axios from 'axios';

// Import mock auth handler (for development only)
import { setupMockAuth } from './mocks/authHandler';

// Extend Window interface to include axios
declare global {
  interface Window {
    axios: typeof axios;
  }
}

window.axios = axios;

// Set up mock auth for development
if (import.meta.env.DEV) {
  console.log('Development mode: Setting up mock authentication');
  setupMockAuth();
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppShell>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <App />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AppShell>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
) 